var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueEditor',{ref:"ve",class:{ 'no-toolbar': !_vm.toolbar },attrs:{"disabled":_vm.disabled,"editorOptions":_vm.editorSettings,"editorToolbar":_vm.editorToolbar},on:{"input":_vm.emitInput,"keyup":_vm.emitKeyup},model:{value:(_vm.current),callback:function ($$v) {_vm.current=$$v},expression:"current"}})
}
var staticRenderFns = []

export { render, staticRenderFns }